module.exports = __webpack_public_path__ + "img/ExcelIcon.e67d42a7.svg";